import { combineReducers } from 'redux';

import companiesState, { companiesInitialState } from './companies';
import companyState, { companyInitialState } from './company';
import selectedUserState, { selectedUserInitialState } from './selectedUser';
import settingsState, { settingsInitialState } from './settings';

export const myAccountInitialState = {
  companiesState: companiesInitialState,
  companyState: companyInitialState,
  settingsState: settingsInitialState,
  selectedUserState: selectedUserInitialState
}

export const myAccountState = combineReducers({
  companyState,
  companiesState,
  settingsState,
  selectedUserState
})